/**
 * send messages from pardot iframes to the parent window
 *
 * catch message here:
 * @see ../iframeHeight.js
 */
(function(){
  function post_height(){
    const msg = JSON.stringify({event:'size', height: document.body.scrollHeight, sourceUrl: window.location.href });
    window.top.postMessage(msg, '*');
  }

  const onload = window.onload;
  window.onload = function(){
    if( onload && typeof onload =='function'){
      onload();
    }
    post_height();
    setInterval(post_height, 1000);
    window.top.postMessage(JSON.stringify({event:'load'}), '*');
  };

})();
